import { Route, Routes } from 'react-router-dom';

import { useMatter } from '@/hooks/useMatter';

import { DeliverablesPage } from './DeliverablesPage';

export const DeliverableRoutes = () => {
  const { matterId } = useMatter();

  if (!matterId) {
    return <div>No matter selected</div>;
  }

  return (
    <Routes>
      <Route path="/" element={<DeliverablesPage matterId={matterId} />} />
      {/* Future: Add detail view if needed */}
      {/* <Route path="/:deliverable_id" element={<DeliverableDetailPage matterId={matterId} />} /> */}
    </Routes>
  );
};
